import script from "./CButtonCollapse.vue?vue&type=script&setup=true&lang=js"
export * from "./CButtonCollapse.vue?vue&type=script&setup=true&lang=js"

import "./CButtonCollapse.vue?vue&type=style&index=0&id=683d9d2c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-683d9d2c"]])

export default __exports__